import React from "react";

export default function Laps() {
  return <ul id="timings" className="mb-5"></ul>;
}
